import { apiClient } from './client';

/**
 * Login with identifier (email or phone) and password.
 * @param {{ identifier: string, password: string }} credentials
 * @returns {{ accessToken, refreshToken, expiresIn, user }}
 */
export async function login(credentials) {
  const { data } = await apiClient.post('/auth/login', credentials);
  return data;
}

/**
 * Refresh access token.
 * @param {string} refreshToken
 * @returns {{ accessToken, refreshToken, expiresIn }}
 */
export async function refreshAccessToken(refreshToken) {
  const { data } = await apiClient.post('/auth/token/refresh', { refreshToken });
  return data;
}

/**
 * Get current user profile (validates token).
 * @returns {{ id, name, email, phone, role, avatar }}
 */
export async function getProfile() {
  const { data } = await apiClient.get('/users/profile');
  return data;
}

/**
 * Change the signed-in user's password. The backend checks the current one
 * (401 when it is wrong) and requires 8-128 characters with an uppercase
 * letter, a lowercase letter and a number.
 * @param {{ currentPassword: string, newPassword: string }} body
 * @returns {{ message: string }}
 */
export async function changePassword(body) {
  const { data } = await apiClient.post('/auth/password/change', body);
  return data;
}

/**
 * Ask for a one-time code to reset a password. The backend answers the same
 * whether or not the phone belongs to an account.
 * @param {string} phone - international format, e.g. +998901234567
 */
export async function requestPasswordReset(phone) {
  const { data } = await apiClient.post('/auth/password/forgot', { phone });
  return data;
}

/**
 * Finish a password reset with the one-time code. The response signs the
 * account in on the backend; the CRM ignores that and sends the user to /login.
 * @param {{ phone: string, code: string, newPassword: string }} body
 */
export async function resetPassword(body) {
  const { data } = await apiClient.post('/auth/password/reset', body);
  return data;
}
